import React from 'react';
import SvgBill from '@icons/bill.svg?react';
import COTimezone from '@components/FigmaComponents/COTimezone.tsx';
import CustomTooltip from '@components/ringil3/Tooltip/CustomTooltip';

interface RampHeaderProps {
  rampId?: string;
  title: string;
  /** Shown in the tooltip only — the column itself stays narrow enough for just the ramp name. */
  locationName?: string;
  timezoneId?: string;
  reservationsCount: number;
  reservationsLabel: string;
}

/** Column header of a ramp — name, timezone hint and a tooltip with the reservation count. */
export const RampHeader: React.FC<RampHeaderProps> = ({ rampId, title, locationName, timezoneId, reservationsCount, reservationsLabel }) => {
  const targetId = rampId ? `ramp-header-${rampId}` : undefined;
  const targetSelector = targetId ? `#${CSS.escape(targetId)}` : undefined;
  const tooltipTitle = locationName ? `${locationName} – ${title}` : title;

  return (
    <div className="flex flex-col px-2 py-2 gap-y-1 items-center justify-center w-full h-full overflow-hidden">
      <div id={targetId} className="flex flex-row w-full min-w-0 gap-x-2.5 items-center justify-center pointer-events-auto">
        <span className="min-w-0 truncate">
          {title}
        </span>
        <span className="shrink-0">
          <SvgBill />
        </span>
      </div>
      {timezoneId && (
        <div className="w-full flex justify-center">
          <COTimezone timezoneId={timezoneId} />
        </div>
      )}
      {targetSelector && (
        <CustomTooltip
          targetSelector={targetSelector}
          content={
            <div className="flex flex-col">
              <span>{tooltipTitle}</span>
              <span className="text-xs opacity-80 whitespace-nowrap">
                {reservationsLabel}: {reservationsCount}
              </span>
            </div>
          }
          position="bottom"
        />
      )}
    </div>
  );
};